import { createSlice } from "@reduxjs/toolkit";

const vendorSlice = createSlice({
  name: "vendor",
  initialState: {
    loading: false,
    error: null,
    vendors: [],
    totalCount: {},
    vendorProfileUiid: 0,
    currentVendor: {
      vendorDetails: {},
      loadedTabs: [],
    }, // Add this for single employee data
  },
  reducers: {
    clearVendorData(state) {
      state.vendors = [];
      state.totalCount = {};
      state.vendorProfileUiid = null;
      state.currentVendor = {
        vendorDetails: {},
        loadedTabs: [],
      }
    },
    clearVendorProfile(state) {
      state.vendorProfileUiid = null;
      state.currentVendor = {
        vendorDetails: {},
        loadedTabs: [],
      };
    },
    setVendorProfile(state, action) {
      console.log("action.payload in set vendor", action.payload);
      state.currentVendor.vendorDetails = {
        ...state.currentVendor.vendorDetails,
        ...action.payload,
      };
    },
    addToDraft(state, action) {
      console.log("action.payload in addToDraft", action.payload);
      state.currentVendor.vendorDetails = {
        ...state.currentVendor.vendorDetails,
        ...action.payload,
      };
    },
    getVendorsStart(state, action) {
      const { limit, page, employmentType } = action.payload;
      state.loading = true;
    },
    getVendorsSuccess(state, action) {
      state.loading = false;
      state.vendors = action.payload.data; // Store paginated data
      state.totalCount = action.payload.totalCount; // Store total count
    },
    getVendorsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // Add Vendor
    addNewVendorStart(state) {
      state.loading = true;
      state.error = null;
    },

    addNewVendorSuccess(state, action) {
      state.vendorProfileUiid = action.payload.data.uiid;
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    addNewVendorFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateVendorStart(state) {
      state.loading = true;
      state.error = null;
    },

    updateVendorSuccess(state) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    updateVendorFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addContactStart(state) {
      state.loading = true;
      state.error = null;
    },

    addContactSuccess(state) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    addContactFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateContactStart(state) {
      state.loading = true;
      state.error = null;
    },

    updateContactSuccess(state) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    updateContactFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    getVendorOneStart(state) {
      state.loading = true;
      state.error = null;
    },
    getVendorOneSuccess(state, action) {
      state.loading = false;
      console.log("get vendor one", action.payload);
      state.vendorProfileUiid = action.payload.uiid
        ? action.payload.uiid
        : state.vendorProfileUiid;
      state.currentVendor.vendorDetails = {
        ...state.currentVendor.vendorDetails,
        ...action.payload,
      };
      state.draft = null;
      state.lastSaved = null;
    },
    // getVendorOneSuccess(state, action) {
    //   state.loading = false;
    //   console.log("get vendor one", action.payload);
    //   state.vendorProfileUiid = action.payload.data.uiid
    //     ? action.payload.data.uiid
    //     : state.vendorProfileUiid;
    //   state.currentVendor.vendorDetails = {
    //     ...state.currentVendor.vendorDetails,
    //     ...action.payload.data,
    //   };
    //   state.draft = null;
    //   state.lastSaved = null;
    // },
    getVendorOneFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetCurrentVendor(state) {
      state.currentVendor = {
        vendorDetails: {},
        loadedTabs: [],
      };
    },
  },
});

export const {
  getVendorsStart,
  getVendorsSuccess,
  getVendorsFailure,
  addNewVendorStart,
  addNewVendorSuccess,
  addNewVendorFailure,
  updateVendorStart,
  updateVendorSuccess,
  updateVendorFailure,
  addContactStart,
  addContactSuccess,
  addContactFailure,
  updateContactStart,
  updateContactSuccess,
  updateContactFailure,
  clearVendorProfile,
  setVendorProfile,
  getVendorOneStart,
  getVendorOneSuccess,
  getVendorOneFailure,
  resetCurrentVendor,
  clearVendorData,
  addToDraft
} = vendorSlice.actions;
export default vendorSlice.reducer;
